import LeadContainers from "./LeadContainer";
import LeadRequestStore from "./LeadRequestStore";

export default LeadRequestStore(LeadContainers); 